// Function to check if all products are hidden and update the UI
function toggleClearFiltersButton() {
  let productItems = document.querySelectorAll('#ProductGridContainer .grid__item');
  let clearFiltersButton = document.getElementById('clearFiltersContainer');
  let clearFiltersOverlay = document.getElementById('clearFiltersOverlay');
  let clearAllLinkButton = document.getElementById('clearAllButton'); // For desktop

  // Mobile specific selectors
  let clearFiltersButtonMobile = document.getElementById('clearFiltersContainerMobile');
  let clearFiltersOverlayMobile = document.getElementById('clearFiltersOverlayMobile');
  let clearAllLinkButtonMobile = document.getElementById('clearAllButtonMobile'); // For mobile

  // Count hidden and visible items
  let hiddenCount = Array.from(productItems).filter(item => item.classList.contains('hide')).length;

  // If all product items are hidden, show the "Clear Filters" button and the overlay
  let allHidden = hiddenCount === productItems.length;

  // Handle desktop view
  if (allHidden && productItems.length > 0) {
    clearFiltersButton.classList.remove('hidden');
    clearFiltersOverlay.classList.remove('hidden'); // Show the overlay
    document.body.classList.add('body-no-scroll');
  } else {
    clearFiltersButton.classList.add('hidden');
    clearFiltersOverlay.classList.add('hidden'); // Hide the overlay
    document.body.classList.remove('body-no-scroll');
  }

  // Handle mobile view
  if (allHidden && productItems.length > 0) {
    clearFiltersButtonMobile.classList.remove('hidden');
    clearFiltersOverlayMobile.classList.remove('hidden'); // Show the overlay
    document.body.classList.add('body-no-scroll');
  } else {
    clearFiltersButtonMobile.classList.add('hidden');
    clearFiltersOverlayMobile.classList.add('hidden'); // Hide the overlay
    document.body.classList.remove('body-no-scroll');
  }

  // Manage visibility of the "Clear All" buttons based on active filters
  let activeFacets = document.querySelectorAll('.active-facets__button');
  let hasActiveFacets = activeFacets.length > 0;

  if (hasActiveFacets) {
    // Show both desktop and mobile "Clear All" buttons
    if (clearAllLinkButton) {
      clearAllLinkButton.classList.remove('hidden');
    }
    if (clearAllLinkButtonMobile) {
      clearAllLinkButtonMobile.classList.remove('hidden');
    }
  } else {
    // Hide both desktop and mobile "Clear All" buttons
    if (clearAllLinkButton) {
      clearAllLinkButton.classList.add('hidden');
    }
    if (clearAllLinkButtonMobile) {
      clearAllLinkButtonMobile.classList.add('hidden');
    }
  }
}

window.toggleClearFiltersButton = toggleClearFiltersButton;

function addHiddenClass() {
  let featuredCollectionElement = document.querySelector('.Featured_collection');
  if (featuredCollectionElement) {
    featuredCollectionElement.classList.add('hidden');
  }
}

function removeHiddenClass() {
  let featuredCollectionElement = document.querySelector('.Featured_collection');
  if (featuredCollectionElement) {
    featuredCollectionElement.classList.remove('hidden');
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    
    // Add specific change event listener for sort dropdowns
    const sortSelects = this.querySelectorAll('select[name="sort_by"]');
    sortSelects.forEach(select => {
      select.addEventListener('change', (event) => {
        console.log('Sort dropdown changed:', event.target.value);
        this.onSubmitHandler(event);
      });
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;

      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('!hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    // After rendering the page, check if all products are hidden
    toggleClearFiltersButton();
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    // Check for hidden products after rendering product grid
    toggleClearFiltersButton();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('!hidden'));

    // Check for hidden products after updating product count
    toggleClearFiltersButton();
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }

    // Check for hidden products after rendering filters
    toggleClearFiltersButton();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      addHiddenClass();
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    console.log('onSubmitHandler called with:', {
      target: event.target,
      targetName: event.target?.name,
      targetValue: event.target?.value,
      eventType: event.type
    });
    
    // Check if this is discount sorting
    if (event.target && event.target.name === 'sort_by' && event.target.value === 'discount-desc') {
      console.log('Discount sorting selected');
      
      // Sort products by discount percentage on the client side
      this.sortProductsByDiscount();
      
      // Update URL to show the sort parameter
      const url = new URL(window.location);
      url.searchParams.set('sort_by', 'discount-desc');
      window.history.pushState({}, '', url);
      
      return;
    }
    
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  sortProductsByDiscount() {
    console.log('sortProductsByDiscount called');
    // FIX: Only select the actual product grid <ul>
    const productGrid = document.querySelector('#product-grid');
    console.log('productGrid found:', productGrid);
    
    if (!productGrid) return;

    // Get all grid items (including non-product items like videos, cards, etc.)
    const allGridItems = Array.from(productGrid.children);
    
    // Filter only product items that have discount data
    const productItems = allGridItems.filter(item => 
      item.classList.contains('grid__item') && 
      item.querySelector('.product_card[data-discount-integer]')
    );
    
    // Get non-product items to preserve their positions
    const nonProductItems = allGridItems.filter(item => 
      !item.classList.contains('grid__item') || 
      !item.querySelector('.product_card[data-discount-integer]')
    );
    
    console.log('Product items found:', productItems.length);
    console.log('Non-product items found:', nonProductItems.length);
    
    if (productItems.length === 0) {
      console.log('No product items with discount data found');
      return;
    }
    
    console.log('Sample product discount values:', productItems.slice(0, 5).map(p => ({
      element: p,
      discount: this.getDiscountValue(p)
    })));

    // Sort only the product items by discount percentage (highest first)
    productItems.sort((a, b) => {
      const discountA = this.getDiscountValue(a);
      const discountB = this.getDiscountValue(b);
      return discountB - discountA; // Descending order (highest discount first)
    });

    console.log('Products after sorting:', productItems.slice(0, 5).map(p => this.getDiscountValue(p)));

    // Create a document fragment to rebuild the grid
    const fragment = document.createDocumentFragment();
    
    // Add non-product items first (videos, etc.) to maintain their original positions
    nonProductItems.forEach(item => {
      fragment.appendChild(item);
    });
    
    // Then add sorted product items
    productItems.forEach(item => {
      fragment.appendChild(item);
    });
    
    // Clear the grid and append the reorganized content
    productGrid.innerHTML = '';
    productGrid.appendChild(fragment);

    // Add visual indicator
    this.addDiscountSortIndicator();
    
    // Reinitialize any functionality that might be needed
    if (typeof reinitializeProductCards === 'function') {
      reinitializeProductCards();
    }
  }

  getDiscountValue(productElement) {
    // Look for data-discount-integer attribute on the product card div
    const discountElement = productElement.querySelector('.product_card[data-discount-integer]');
    if (discountElement) {
      return parseInt(discountElement.getAttribute('data-discount-integer')) || 0;
    }
    
    // Fallback: check if the productElement itself has the attribute
    if (productElement.hasAttribute('data-discount-integer')) {
      return parseInt(productElement.getAttribute('data-discount-integer')) || 0;
    }
    
    return 0;
  }

  addDiscountSortIndicator() {
    // Remove existing indicator
    const existing = document.querySelector('.discount-sort-indicator');
    if (existing) existing.remove();

    // Add new indicator
    const productGrid = document.querySelector('#product-grid, #ProductGridContainer, .product-grid');
    if (productGrid) {
      const indicator = document.createElement('div');
      indicator.className = 'discount-sort-indicator';
      indicator.innerHTML = '<div style="background: #f0f8ff; padding: 10px; margin: 10px 0; border-left: 4px solid #007acc; font-weight: bold;">🔥 Products sorted by highest discount percentage</div>';
      productGrid.parentElement.insertBefore(indicator, productGrid);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if ( value > max ) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

// Function to close the menu
function closeMenu() {
  let menuElement = document.querySelector('.mobile-facets__disclosure');
  if (menuElement) {
    menuElement.classList.remove('menu-opening');
    menuElement.removeAttribute('open');
  }
}

// Add event listeners to the elements that should trigger the closing of the menu
document.querySelector('.mobile-facets__close').addEventListener('click', closeMenu);
document.querySelector('.mobile-facets__close--no-js').addEventListener('click', closeMenu);

// Check for discount sorting on page load
document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('sort_by') === 'discount-desc') {
    // Find the facet form and trigger discount sorting
    const facetForm = document.querySelector('facet-filters-form');
    if (facetForm) {
      setTimeout(() => {
        facetForm.sortProductsByDiscount();
      }, 100);
    }
  }
});
